import { IApplicationState } from '../../../../../../../types/types';
import { EBoardSetting } from '../../../../boardDetails/details/TabDetails/components/TabDetails/types';
import {
    getIsNewFeatureBoardSplitSettings
} from '../../../../../../../store/model/authUser/selectors/featuresSeen/getIsNewFeatureBoardSplitSettings';

export const getBoardSubTab = (
    state: IApplicationState,
): EBoardSetting => {
    if (getIsNewFeatureBoardSplitSettings(state)) return;
    return EBoardSetting.INFO;
}
